import { useState } from 'react'
import { Icon } from '@iconify/react'
import NavigationButton from './NavigationButton'
import {
  SideNavigation,
  Container,
  LogoContainer,
  NavigationContainer,
  IconContainer,
  ExpandIconContainer,
  WhiteLogo,
  GradientLogo,
  NavigationSectionsContainer,
  Arrow,
  Tooltip,
} from './Sidebar.style'
import {
  useNavigation,
  useMenuActions,
  useNavigationItems,
} from './Sidebar.utils'

const SIDEBAR_PREFIX = 'sidebar'
const NAV_BTN_PREFIX = 'nav-btn'
const USER_ACTION_BTN_PREFIX = 'user-action-btn'

const Sidebar = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false)
  const { isCurrentLocation, handleRouteChange } = useNavigation()
  const { actions, refreshActions } = useMenuActions()

  const { navigationItems, userActions } = useNavigationItems()

  const handleNavigationClick = (route: string, external?: boolean) => {
    if (external) return window.open(route, '_blank')
    handleRouteChange(route)
    refreshActions()
    setSidebarOpen(false)
  }

  return (
    <Container>
      <SideNavigation
        className="transition-container"
        isExpanded={isSidebarOpen}
      >
        <LogoContainer>
          <IconContainer>
            {isSidebarOpen ? <GradientLogo /> : <WhiteLogo />}
          </IconContainer>
        </LogoContainer>
        <NavigationSectionsContainer>
          <NavigationContainer>
            {navigationItems.map(
              (
                { route, icon, title, action, standaloneIcon, external },
                idx
              ) => {
                const IconComponent = icon
                return (
                  <Tooltip
                    title={isSidebarOpen ? '' : title}
                    placement="right"
                    key={`tooltip-${route}`}
                  >
                    <div>
                      <NavigationButton
                        isCurrentLocation={isCurrentLocation(route)}
                        onClick={() => handleNavigationClick(route, external)}
                        key={route}
                        icon={
                          standaloneIcon ? (
                            <IconComponent />
                          ) : (
                            <Icon icon={icon} />
                          )
                        }
                        text={title}
                        isExpanded={isSidebarOpen}
                        actionRequired={action && actions[action]}
                        id={`${NAV_BTN_PREFIX}-${idx}`}
                      />
                    </div>
                  </Tooltip>
                )
              }
            )}
          </NavigationContainer>
          <NavigationContainer>
            {userActions.map((userAction, idx) => (
              <Tooltip
                title={isSidebarOpen ? '' : userAction.title}
                placement="right"
                key={`tooltip-${userAction.route}`}
              >
                <div>
                  <NavigationButton
                    isCurrentLocation={isCurrentLocation(userAction.route)}
                    onClick={() =>
                      handleNavigationClick(
                        userAction.route,
                        userAction.external
                      )
                    }
                    key={userAction.route}
                    icon={<userAction.icon />}
                    text={userAction.title}
                    isExpanded={isSidebarOpen}
                    id={`${USER_ACTION_BTN_PREFIX}-${idx}`}
                  />
                </div>
              </Tooltip>
            ))}
          </NavigationContainer>
        </NavigationSectionsContainer>
        <ExpandIconContainer
          isExpanded={isSidebarOpen}
          onClick={() => setSidebarOpen(!isSidebarOpen)}
          id={`${SIDEBAR_PREFIX}-toggle-btn`}
        >
          <Arrow direction={isSidebarOpen ? 'left' : 'right'} />
        </ExpandIconContainer>
      </SideNavigation>
    </Container>
  )
}

export default Sidebar
